import React from 'react';
import { IInfoCluster } from '@mayfield/sanity';
import cn from 'classnames';
import { AnimatedGraphic } from '@mayfield/common/components';
import * as styles from './styles.module.scss';

interface IProps extends IInfoCluster {
  className?: string;
}

const Cluster = ({ graphic, heading, text, subheading, className }: IProps) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.animatedGraphicContainer}>
        <AnimatedGraphic url={graphic.video.asset.url} />
      </div>

      <div className={styles.headings}>
        <h3 className={cn('h4', styles.heading)}>{heading}</h3>

        {subheading && <h4 className={cn('caption')}>{subheading}</h4>}
      </div>

      <p className={cn('b2', styles.text)}>{text}</p>
    </div>
  );
};

export default Cluster;
